export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/magento.7a10f1c.svg";